<script>
import SimplePlaceholder from '../../kit/SimplePlaceholder.vue';

export default {
  name: 'CompareListPlaceholder',
  components: { SimplePlaceholder },
};
</script>

<template>
  <table class="min-w-full divide-y divide-orange-diagomics-light">
    <thead class="bg-gray-50">
      <tr class="divide-x divide-gray-200">
        <th class="w-1/4"></th>
        <th v-for="index in 3" :key="index" class="w-1/4">
          <div class="w-full flex justify-center py-6 px-6">
            <SimplePlaceholder />
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="even:bg-gray-50" v-for="index in 12" :key="index">
        <td class="font-bold py-2 px-6">
          <SimplePlaceholder class="w-32" />
        </td>
        <td v-for="index in 3" :key="index" class="py-2 px-6 border-l border-gray-diagomics">
          <SimplePlaceholder class="w-24" />
        </td>
      </tr>
    </tbody>
  </table>
</template>
